/**
 * @author       esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  styles.ts
 */

import { type Theme, css } from '@emotion/react'
import { BREAKPOINT_DESKTOP } from '@zcode-ui/themes'
import { gray70, gray90 } from '../../../../../../styles/colors'

export const header = css`
  display: flex;
  align-items: center;
  margin-top: 4px;
`

export const headerTextStrong = ({ typography }: Theme) => css`
  font-weight: ${typography?.fontWeightBold ?? 'bold'};
`

export const locationText = ({ colors, typography }: Theme) => css`
  display: flex;
  margin-top: 6px;

  color: ${colors?.textLightest ?? gray70};
  font-size: ${typography?.fontSize14 ?? '14px'};
  line-height: 120%;
  white-space: nowrap;

  .hood {
    color: ${gray90};
  }
  &:hover {
    color: ${colors?.textLight ?? gray70};
  }

  @media (min-width: ${BREAKPOINT_DESKTOP}) {
    a {
      &:hover {
        color: ${colors?.textLight ?? gray70};
        text-decoration: none;
      }
    }
  }
`

export const hide = css`
  width: 0;
  height: 0;
  margin: 0;

  visibility: hidden;
`

export const address = css`
  display: block;
  overflow: hidden;
  font-style: normal;

  text-overflow: ellipsis;
`

export const propertyTypeText = ({ typography }: Theme) => css`
  margin: 0 0 0 5px;

  font-weight: ${typography?.fontWeightRegular ?? 'normal'};
`
